import classNames from 'classnames'
import React from 'react'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import { sendTeaCommEvent } from 'lib/tea-analyze'

export interface IItemInfo {
  title: string
  count: number
  group_id_str: string
  is_pgc_article: 0 | 1
}
interface ILeaderboard {
  type: 'qa' | 'article' | 'video'
  data: IItemInfo[]
  seriesId: number
  className?: string
}

interface IItem {
  index: number
  data: IItemInfo
  type: 'qa' | 'article' | 'video'
  onClick?: () => void
}

const Item = (props: IItem) => {
  const { index, data, type, onClick } = props
  const { title, count, group_id_str, is_pgc_article } = data
  return (
    <a
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      href={`${is_pgc_article ? '' : '/ugc'}/article/${group_id_str}`}
      className="card-link"
      onClick={onClick}
    >
      <div className="card">
        <span
          className={classNames('pagination', {
            p1: index === 0,
            p2: index === 1,
            p3: index === 2,
          })}
        >
          {index + 1}
          {index > 2 && '.'}
        </span>
        <div className="content">
          <p className="line-1">{title}</p>
          <span>
            {formatNumber(count)}
            {type === 'qa' ? `人评论` : `人阅读`}
          </span>
        </div>
        <style jsx>
          {`
            .card {
              height: 38px;
              margin-bottom: 8px;
              display: flex;
              align-items: top;
            }
            .card-link:last-child .card {
              margin-bottom: 0;
            }
            .pagination {
              margin-right: 10px;
              width: 18px;
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex: 0 0 auto;
              color: #979aa8;
            }
            .p1 {
              width: 18px;
              height: 18px;
              border-radius: 1px;
              background-color: #e52021;
              color: white;
              margin-right: 9px;
            }
            .p2 {
              width: 18px;
              height: 18px;
              border-radius: 1px;
              background-color: #e65802;
              color: white;
              margin-right: 9px;
            }
            .p3 {
              width: 18px;
              height: 18px;
              border-radius: 1px;
              background-color: #f5b42f;
              color: white;
              margin-right: 9px;
            }
            .content p {
              font-size: 14px;
              line-height: 18px;
              color: #1f2129;
              max-width: 264px;
            }
            .content span {
              font-size: 12px;
              line-height: 18px;
              color: #979aa8;
            }
          `}
        </style>
      </div>
    </a>
  )
}

export default function Leaderboard(props: ILeaderboard) {
  const { type, data = [], className, seriesId } = props
  let title = ''
  switch (type) {
  case 'article':
    title = '车系文章排行'
    break
  case 'video':
    title = '车系视频排行'
    break
  case 'qa':
    title = '问答排行'
    break
  }
  return data.length > 0 ? (
    <div className={classNames('leaderboard', className)}>
      <div className="title">{title}</div>

      {data.map((item, index) => (
        <Item
          index={index}
          data={item}
          key={index}
          type={type}
          onClick={() => {
            sendTeaCommEvent('click_group_list_item', {
              module_title: title,
              group_id: item.group_id_str,
              car_series_id: seriesId,
            })
          }}
        />
      ))}

      <style jsx>
        {`
          .title {
            font-size: 18px;
            font-weight: 500;
            color: #1f2129;
            margin-bottom: 24px;
          }
          .leaderboard {
            width: 320px;
            height: 545px;
            padding: 20px 16px;
            background-color: white;
          }
        `}
      </style>
    </div>
  ) : null
}
